import type { Variants } from 'motion/react';

// Height transition completes first, then visual effects continue
const defaultDuration = 0.5;
const glintDuration = 1.5;
const fullDuration = 1.5;

/**
 * Animation variants for HudBox entrance with coordinated height reveal and visual effects.
 * CSS custom properties (--color-progress, --turn-progress, --pos-progress, --transition) drive shader-like effects in the component's styles.
 */
export const containerTransition: Variants = {
  hidden: {
    '--hud-transition-progress': 0,
    // '--color-progress': 0,
    // '--turn-progress': 0.5,
    // '--pos-progress': 0,
  },
  show: {
    '--hud-transition-progress': 1,
    // // Pulse color effect: start at 0, hold, peak at 1, fade back to 0
    // '--color-progress': [0, 0, 1, 0],
    // // Rotation effect: start centered (0.5), hold, then rotate to final position (0.3)
    // '--turn-progress': [0.5, 0.5, 0.3],
    // // Position shift: start at 0, hold during height transition, then animate to final position
    // '--pos-progress': [0, 0, 1],
    transition: {
      default: {
        duration: defaultDuration,
      },
      '--color-progress': {
        duration: fullDuration,
        // Wait for height transition (0.3s) before starting color pulse
        times: [0, defaultDuration / glintDuration, 0.4, 1],
        when: 'afterChildren',
      },
      '--turn-progress': {
        duration: fullDuration,
        times: [0, defaultDuration / glintDuration, 1],
        when: 'afterChildren',
      },
      '--pos-progress': {
        duration: fullDuration,
        times: [0, defaultDuration / glintDuration, 1],
        when: 'afterChildren',
      },
    },
  },
};
